import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
// import qs from "qs";
import {
  getLocalIdentity,
  getRequestIdentityHeader,
} from "@meitu/xdesign-identity";
import CODE from "../constants/code";
import { getClientID, PREVIEW_MODE } from "@/constants";
import { getQuery } from "./query";
import { checkIsInSdk } from "./sdk";
import store from "@/store";
import { waitUntilGetGid } from "./gid";
import { getOsType, getSource, isPcPlatform } from ".";
import { MTCCData, MTCCDataScene, Scene } from "@/constants/workbench";
import {
  getClientLanguage,
} from "@meitu/xdesign-widgets/dist/utils";
import { getCountryCode } from '@meitu/xdesign-utils';
import { getMTCCClient } from "@meitu/xdesign-utils";

// 接口公共参数
export const getCommonParams = async () => {
  if (typeof window === "undefined") {
    return {
      client_id: getClientID(),
      // client_language: getClientLanguage("cn"),
      // country_code: await getCountryCode(),
      gid: "",
      preview_mode: PREVIEW_MODE,
      // enter_source: await getSource(),
    };
  }
  const gid = await waitUntilGetGid();
  return {
    client_id: getClientID(),
    client_language: getClientLanguage("zh-Hans"),
    country_code: await getCountryCode(),
    gid,
    enter_source: await getSource(),
    preview_mode: PREVIEW_MODE,
  };
};

// 成本分摊埋点公共参数
const getMtccCommonParams = async () => {
  const isToB = checkIsInSdk();

  const params = {
    gid: (await getCommonParams()).gid,
    app_id: (window as any)._appId || undefined,
    osType: await getOsType(),
    isToB,
    // 设计室web:2
    // 内嵌:6
    virtualId: (await isPcPlatform()) ? "6" : "2",
    functionInfo: {
      name: MTCCDataScene[Scene.AiPPT],
    },
    positionInfo: {
      level1: MTCCDataScene[Scene.AiPPT],
    },
    uid: store.getState().userModel.userInfo?.id,
    isPcPlatform: await isPcPlatform(),
    isTeam: !!getLocalIdentity()?.oid,
    preview_mode: PREVIEW_MODE,
  };

  return params;
};

// 成本分摊埋点 header
export const genMtccHeader = async (config?: any) => {
  if (!config) {
    // 无配置则默认为抠图
    config = {
      key: "plugin-matting",
    };
  }
  const MatchMTCC = Object.keys(MTCCData).find(
    (key) => config.key === key || config.url?.indexOf(key) >= 0
  ) as keyof typeof MTCCData;

  const isToB = config.headers?.["Enterprise-Access-Key"]
    ? true
    : checkIsInSdk();

  if (MatchMTCC) {
    // 根据 url 匹配到的 MTCCData 的 key，获取对应的 position
    const findKey = MTCCData[MatchMTCC].positionKey;
    const positionKey = findKey && config.data[findKey];

    const specialPosition =
      (positionKey && (MTCCData[MatchMTCC].position as any)?.[positionKey]) ||
      "";
    const defaultMtccParams = await getMtccCommonParams();
    const params = {
      ...defaultMtccParams,
      isToB,
      mediaType: '',
      resMediaType: '',
      functionInfo: {
        ...defaultMtccParams.functionInfo,
        name:
          defaultMtccParams.functionInfo.name ||
          MTCCData[MatchMTCC].function ||
          "",
      },
      positionInfo: {
        ...defaultMtccParams.positionInfo,
        level1:
          specialPosition ||
          MTCCData[MatchMTCC].position.default ||
          (MTCCData[MatchMTCC].position as any)[Scene.AiPPT] ||
          "",
      },
    };

    console.log({ MatchMTCC: params });

    const headerString = await getMTCCClient(params);
    return headerString;
  }
};

// 全局的 axios 默认值
// ATTENTION: 这里的默认值会导致 x-design-widgets NavVipEntrance 组件请求接口错误
// axios.defaults.baseURL = "";
axios.defaults.withCredentials = true;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

// 接口公共参数
// export const serverCommonParams = {
//   client_id: getClientID(),
//   preview_mode: PREVIEW_MODE,
// } as Record<string, string | number>;

// 添加请求拦截器
axios.interceptors.request.use(
  async (config: any) => {
    const commonParams = await getCommonParams();
    if (config.method === "post") {
      const data = Object.assign({}, commonParams, config.data || {});

      try {
        const headers = await genMtccHeader(config);
        if (headers) {
          config.headers["x-mtcc-client"] = headers;
        }
      } catch (error) {
        console.log(error);
      }

      if (
        config.headers["Content-Type"] === "application/x-www-form-urlencoded"
      ) {
        // config.data = qs.stringify(data);
      } else {
        config.data = data;
      }
      config.params = {
        ...commonParams,
        ...config.params,
      };
    } else if (config.method === "get") {
      config.params = Object.assign(
        {
          timestamp: new Date().getTime(),
        },
        commonParams,
        config.params || {}
      );
    }

    return config;
  },
  (error: any) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  async (response: any) => {
    if (!["get", "post"].includes(response.config?.method || ""))
      return response;

    // const config: RequestConfig = response.config;
    // const hideErrorToast = config.hideErrorToast;
    // console.log('hideErrorToast: ', hideErrorToast);

    // 只针对get/post请求方式的返回做处理
    const code = response.data.error_code;
    // const msg = response.data.msg;
    // console.log('msg: ', msg);

    if (code !== CODE.OK) {
      // if (!hideErrorToast) message.error(msg || '请求出错，请稍后再试');
    }

    // 对响应数据做点什么
    return response;
  },
  (error: any) => {
    // message.error('您的网络发生异常，无法连接服务器');
    // return Promise.reject("您的网络发生异常，无法连接服务器");
    const res = error.response;
    const msg = res?.data?.message || res?.data?.msg || "请求出错，请稍后再试";
    console.log("error: ", error);
    return Promise.reject({ msg, network: true, data: res?.data || {} });
  }
);

/**
 * 拓展配置项
 */
interface CustomizeConfigs {
  // 默认展示错误提示
  hideErrorToast?: boolean;
  // access_token?: string;
}

interface RequestConfig extends AxiosRequestConfig, CustomizeConfigs {}

export default function request<T>(
  api: string,
  config?: RequestConfig
): Promise<AxiosResponse<T>> {
  const requestOptions: RequestConfig = Object.assign(
    {
      hideErrorToast: false,
    },
    {
      url: api,
    },
    config
  );

  if (!requestOptions.headers) {
    requestOptions.headers = {};
  }

  // 团队版请求头标识
  requestOptions.headers = Object.assign(
    requestOptions.headers,
    getRequestIdentityHeader()
  );

  let token = "";
  if (typeof window !== "undefined") {
    const query = getQuery();
    token =
      query.accessToken || window.localStorage.getItem("access_token") || "";
  }
  requestOptions.headers.access_token = token;

  return axios(requestOptions);
}
